import { BaseBonusCongratulationsPopup } from './BaseBonusCongratulationsPopup';

export class BonusCongratulationsMobilePopup extends BaseBonusCongratulationsPopup {
  execute({ root }) {
    super.execute({ root });
    return this.loadResource([]).then(() => {
      const container = this.getPopup();
      root.addChild(container);
    });
  }
}

export const bonusCongratulationsMobilePopup = new BonusCongratulationsMobilePopup();